export default "__VITE_ASSET__H_LXjC6g__"